/* Les mots du barème, écrits une fois pour les deux écrans qui le montrent :
   la liste des commissions et la fiche de vente. */

import { euroPrecis, pourcent } from "@/lib/format";
import type { ModePart, ModeRegle } from "@/types/metier";

export const NOM_MODE: Record<ModeRegle | "mixte", string> = {
  pct: "%",
  unite: "€/u",
  mixte: "mixte",
};

/** Comment le barème usine se formule, en toutes lettres. */
export const MODE_LONG: Record<ModeRegle, string> = {
  pct: "% du montant facturé",
  unite: "€ par unité vendue",
};

export const NOM_PART: Record<ModePart, string> = {
  points: "points du taux usine",
  pct: "% de la commission",
  unite: "€ par unité vendue",
};

/** Le pas d'un champ de saisie : un barème à l'unité se joue au millime. */
export const PAS: Record<ModeRegle | ModePart, number> = {
  pct: 0.01,
  points: 0.01,
  unite: 0.001,
};

/** Un barème s'écrit avec son unité : 6,00 % ou 0,060 €/u. */
export function valeurBareme(mode: ModeRegle | ModePart, valeur: number): string {
  if (mode === "unite") return `${euroPrecis(valeur)}/u`;
  if (mode === "points") return `${valeur.toFixed(2).replace(".", ",")} pts`;
  return pourcent(valeur);
}
